module.exports = __webpack_public_path__ + "img/what1.994ea808.png";